export enum NewUserType {
  NotSet = 0,
  Landlord = 1,
  Tenant = 2,
  Contractor = 3,
  Owner = 4,
}
